import React, { useCallback, useEffect, useState, useMemo } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Box, Button, Flex, HStack, Text, VStack } from '@chakra-ui/react'
import UnderlineHeading from '../../../../components/UnderlineText/UnderlineHeading'
import { useLabels } from '../../../../utils/hooks/useLabels/useLabels'
import { employeeManagementColumns } from '../../../../components/Table/columns/employeeManagementColumns'
import { useFoundEmployee } from '../../../../utils/hooks/employees/useFoundEmployee'
// import Table from '../../../../components/Table/Table'
import Filters from '../../../../components/Table/Filters/Filters'
import ExportEmployees from './ExportEmployees'
import useOrder from './../../../../utils/hooks/useOrder/useOrder'
// import TableLocal from '../../../../components/Table/TableLocal/TableLocal'

import Table from './../../../../components/Table/Table'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserTimes } from '@fortawesome/free-solid-svg-icons/faUserTimes'

export default function EmployeeManagement() {
  const { texts } = useLabels()
  const navigate = useNavigate()
  const { orderAsc, orderBy, onSort } = useOrder()
  const orderData = useMemo(() => {
    return {
      orderBy,
      orderAsc,
    }
  }, [orderBy, orderAsc])

  const {
    totalPages,
    page,
    employees,
    actualFilters,
    allEmployees,
    handleChangePage,
    applyFilters,
  } = useFoundEmployee({
    sOrderby: orderData.orderBy,
    bAsc: orderData.orderAsc,
    sEstado: ['AC'],
    sBusqueda: '',
    bReporte: true,
  })
  const [employeesCopy, setEmployeesCopy] = useState([])

  useEffect(() => {
    if (employeesCopy.length === 0 && allEmployees.length > 0) {
      setEmployeesCopy(allEmployees)
    }
  }, [employeesCopy, allEmployees])

  useEffect(() => {
    applyFilters({
      ...actualFilters,
      sEstado: actualFilters.sEstado.split(','),
      sOrderby: orderBy,
      bAsc: orderAsc,
      bReporte: true,
    })
  }, [orderBy, orderAsc, employeesCopy])

  const onEmployeeClick = useCallback((sEmpleado) => {
    navigate(`employee/${sEmpleado}`)
  }, [])

  return (
    <Flex direction="column" w="100%" overflowY="hidden" mb="100px">
      <Box>
        <UnderlineHeading
          text={texts.employee_management}
          variant="h5"
          subtext={texts.employee_management_description}
          subVariant="body1"
        />
      </Box>
      <VStack mt="32px" w="100%" alignItems="flex-start" mb="40px">
        <Filters handleSearch={applyFilters} />
        <Box mt="36px" w="100%">
          {employees && (
            <Table
              onSort={onSort}
              orderBy={orderBy}
              orderAsc={orderAsc}
              columns={employeeManagementColumns || []}
              data={employees || []}
              onEmployeeClick={onEmployeeClick}
              withPagination
              paginationProps={{
                totalPages: totalPages,
                actualPage: page,
                handlePageChange: handleChangePage,
              }}
            />
            // <TableLocal
            //   onSort={onSort}
            //   orderAsc={orderAsc}
            //   orderBy={orderBy}
            //   data={allEmployees || []}
            //   onEmployeeClick={onEmployeeClick}
            //   columns={employeeManagementColumns || []}
            // />
          )}
        </Box>
      </VStack>

      <HStack pb={10}>
        <ExportEmployees
          fileName={'Socios'}
          data={allEmployees}
          filters={actualFilters}
        />

        <Button
          as={Link}
          width={350}
          height="56px"
          variant="white"
          borderRadius={6}
          background="#EEEEEE"
          to="massive-termination"
          border="1px solid #DDDDDD"
          boxShadow="0px 2px 26px 0px #79797940"
        >
          <HStack>
            <FontAwesomeIcon icon={faUserTimes} />
            <Text variant="p">Realizar desvinculación masiva</Text>
          </HStack>
        </Button>
      </HStack>
    </Flex>
  )
}
